export const Portfolio = [
  {
    name: "Electronic Devices Project Website (Group 7)",
    url: "https://alishaiaz.github.io/Project-ElectronicDeviceLabPortfolio",
  },
  {
    name: "Crowdfunding Website",
    url: "https://basiccrowdfundingwebsite.000webhostapp.com/",
  },
  {
    name: "Crowdfunding Website (Repo)",
    url: "https://github.com/aliShaiaz/Crowdfunding-Website",
  },
];
export const Contact = [
  {
    name: "Facebook",
    url: "https://facebook.com/alishaiaz.official",
  },
  {
    name: "Linked In",
    url: "https://www.linkedin.com/in/alishaiaz/",
  },
  {
    name: "Github",
    url: "https://github.com/alishaiaz",
  },
  {
    name: "ResearchGate",
    url: "https://www.researchgate.net/profile/Shaiaz-Ali",
  },
  {
    name: "_Resume of Shaiaz Ali",
    url: "https://github.com/aliShaiaz/resume/blob/main/_Resume%20of%20Shaiaz%20Ali.pdf",
  },
];
